export default "__VITE_ASSET__D5i4Qr7G__"